import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAppEventListener } from 'src/common/events/appEvents';
import { useAppContainerContext } from '../AppContainerContext';
import type { SteeringResponse } from './types';
import { connectCalendarExample } from './__mocks__';

// TODO: Replace with real API call when endpoint exists:
// import { api } from 'src/common/utils/api';

export function useNextBestAction() {
  const { contentMeta } = useAppContainerContext();
  const clientId = contentMeta?.entityId ?? null;
  const queryClient = useQueryClient();
  const queryKey = ['steering', 'next-best-action', { client_id: clientId }];

  const query = useQuery<SteeringResponse>({
    queryKey,
    // TODO: Replace with: api.post<SteeringResponse>('steering/next-best-action', { client_id: clientId }).then(r => r.data)
    queryFn: connectCalendarExample,
  });

  useAppEventListener(() => {
    queryClient.invalidateQueries({ queryKey: ['steering'] });
  });

  return query;
}
